import { initialsOf } from '../../lib/initials';
import { Avatar } from './avatar';

/** A few people as overlapping grey discs (Figma A05.1 "Team"). Shows nothing for nobody. */
export function AvatarStack({ names, className }: { names: string[]; className?: string }) {
  if (names.length === 0) return null;
  return (
    <span
      className={`flex -space-x-(--mbm-space-1) ${className ?? ''}`}
      role="group"
      aria-label={`Team: ${names.join(', ')}`}
    >
      {names.map((name) => (
        <Avatar key={name} tone="neutral" size="xxs" initials={initialsOf(name)} className="ring-2 ring-surface-card" />
      ))}
    </span>
  );
}
